import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Transition as _Transition, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "search-criteria",
  ref: "wrapper"
}
const _hoisted_2 = { class: "search-city-criteria" }
const _hoisted_3 = { class: "search-date-criteria" }
const _hoisted_4 = { class: "search-adults-criteria" }
const _hoisted_5 = { class: "search-criteria-btn" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }

import { ref, computed, onBeforeMount, nextTick, watch } from 'vue';
  import { useStore } from 'vuex';
  import { useRoute, useRouter } from 'vue-router';
  import { useI18n } from 'vue-i18n';
  import {
    HotelDetailsML,
    HotelSearchCriteria,
    IHotelSearchCriteria,
    Search,
    Suggest,
  } from 'types';
  import { parse, format } from 'date-fns';
  import debounce from 'lodash/debounce';
  import SuggestsSearchComponent from './SuggestsSearchComponent.vue';
  import ButtonComponent from './ButtonComponent.vue';
  import DatepickerDefaultComponent from './VueDatepicker/DatepickerDefaultComponent.vue';
  import HotelsTravelersPopupComponent from './Hotels/HotelsTravelersPopupComponent.vue';
  import { SearchIcon } from '@/views/icons';
  import { lazyComponent } from '@/router/routes';
  import Emitter, { EVENT_NAMES } from '@/plugins/emitter';
  import { useHotelSearchRouteHandler } from '@/mixins/searchHotels';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'HotelsSearchCriteriaComponent',
  props: {
    traveleresFieldClassName: String,
  },
  emits: ['onClickSearch'],
  setup(__props, { emit }) {

  const HeaderHotelsFilterComponent = lazyComponent(
    'Filter/HeaderHotelsFilterComponent',
  );

  

  

  const inputId = Suggest.Ids.HOTEL;
  const { t } = useI18n();
  const store = useStore();
  const route = useRoute();
  const router = useRouter();

  const onCriteriaChangeDebounced = debounce(onClickSearch, 600);

  const datepickerRef =
    ref<InstanceType<typeof DatepickerDefaultComponent>>(null);
  const noSuggestError = ref<boolean>(false);

  const isMobile = computed<boolean>(() => store.state.support.isMobile);
  // const searchCriteria = computed<HotelSearchCriteria>(
  //   () => store.state.searchCriteria.local,
  // );
  const searchCriteria = computed<HotelSearchCriteria>(
    () => store.state.searchCriteria.criteria,
  );
  const hotelModel = computed<HotelDetailsML.Details>(
    () => store.state.hotel.hotel,
  );

  const localCriteria = ref<IHotelSearchCriteria>(
    searchCriteria.value.copyWith({}),
  );

  const { handleRoute, zipFilters } = useHotelSearchRouteHandler();

  const checkin = computed(() => {
    return parse(localCriteria.value.checkin);
  });
  const checkout = computed(() => {
    return parse(localCriteria.value.checkout);
  });

  async function setDates(dates: { in: Date; out: Date }) {
    const inFormatted = format(dates.in, HotelSearchCriteria.datePattern);
    const outFormatted = format(dates.out, HotelSearchCriteria.datePattern);
    if (
      inFormatted === localCriteria.value.checkin &&
      outFormatted === localCriteria.value.checkout
    ) {
      return;
    }

    localCriteria.value.checkin = format(
      dates.in,
      HotelSearchCriteria.datePattern,
    );
    localCriteria.value.checkout = format(
      dates.out,
      HotelSearchCriteria.datePattern,
    );

    onCriteriaChange();
  }

  function onTravelersChange() {
    onCriteriaChange();
  }

  function isUpdateCurrentHotel() {
    return (
      route.name === 'hotel' &&
      hotelModel.value &&
      hotelModel.value.id === searchCriteria.value.id
    );
  }

  async function onSuggest(selectedSuggest: Suggest.SelectedSuggest) {
    const query: Suggest.Query = {
      text: selectedSuggest.suggest.title,
      type: Suggest.QueryType.TYPE,
    };

    store.commit('suggest/setQueryByIndex', {
      query: query,
      id: selectedSuggest.inputId,
    });
    onSelectSuggest({
      suggest: selectedSuggest.suggest as Suggest.Suggest<Suggest.HotelSuggest>,
      id: selectedSuggest.inputId,
    });

    setCriteriaIdBySuggest(
      selectedSuggest.suggest.source as Suggest.HotelSuggest,
    );

    onCriteriaChange();
  }

  function convertLatLonToId(lat: number, lon: number) {
    return `G${lat},${lon}`;
  }

  async function setCriteriaIdBySuggest(suggest: Suggest.HotelSuggest) {
    const idIsGType = suggest.id.includes('G');
    const itsHotelPage = route.name === 'hotel';

    if (idIsGType) {
      setId({
        id: suggest.id,
        hotelId: null,
      });
      return;
    }

    if (itsHotelPage && suggest.id === localCriteria.value.id) {
      return;
    }

    const { lat, lon } = suggest;

    if (!lat || !lon) {
      return;
    }

    const convertedFromLatLon = convertLatLonToId(suggest.lat, suggest.lon);

    setId({
      id: convertedFromLatLon,
      hotelId: suggest.id,
    });
  }

  function onCriteriaChange() {
    if (route.name !== 'main') {
      onCriteriaChangeDebounced();
    }
  }

  onBeforeMount(() => {
    if (route.name === 'main' && !searchCriteria.value.inited()) {
      store.dispatch('searchCriteria/initDefaultSearchCriteria');
    }

    store.commit('suggest/initSuggestContainer', inputId);

    if (route.name === 'main') {
      const suggest: Suggest.Suggest<Suggest.HotelSuggest> =
        store.getters['suggest/getSuggest'](inputId);

      if (suggest && suggest.source && suggest.source.title !== suggest.title) {
        const copy = { ...suggest };
        copy.title = copy.source.title;
        copy.subtitle = copy.source.sub_title;
        onSelectSuggest({ suggest: copy, id: inputId });
      }
    }
  });

  async function onClickSearch(force?: boolean) {
    try {
      const selectedSuggest: Suggest.Suggest<Suggest.HotelSuggest> =
        store.getters['suggest/getSuggest'](inputId);
      const suggests = store.getters['suggest/getSuggests'](inputId);

      if (
        (selectedSuggest && selectedSuggest.source) ||
        searchCriteria.value.id
      ) {
        if (!searchCriteria.value.id && selectedSuggest.source.id) {
          setCriteriaIdBySuggest(
            selectedSuggest.source as Suggest.HotelSuggest,
          );
        }
      } else if (suggests.length > 0) {
        const firstSuggestOnList: Suggest.Suggest<Suggest.HotelSuggest> =
          suggests[0];

        onSelectSuggest({
          suggest: firstSuggestOnList,
          id: inputId,
        });
        setCriteriaIdBySuggest(firstSuggestOnList.source);
      } else {
        throw new Error('No suggest found');
      }

      await datepickerRef.value?.onDoneClicked(true);

      if (isMobile.value && !force) {
        return;
      }

      store.commit('searchCriteria/updateSearchCriteria', localCriteria.value);
      push();
    } catch {
      noSuggestError.value = true;
      nextTick(() => {
        Emitter.$emit(EVENT_NAMES.SUGGEST_ERROR);
      });
    }
  }

  async function push() {
    if (!searchCriteria.value.id) {
      Emitter.$emit(EVENT_NAMES.SUGGEST_ERROR);
      return;
    }

    const query = searchCriteria.value.getRouteQuery();

    // if (IsSearchAndLocalSame.value) {
    //   if (route.query.repeat) {
    //     const repeat = parseInt(route.query.repeat as string);
    //     query['repeat'] = repeat + 1;
    //   } else {
    //     query['repeat'] = 1;
    //   }
    // }

    store.commit('search/setMapBounds', undefined);

    if (searchCriteria.value.itsHotelId() && isUpdateCurrentHotel()) {
      router
        .push({ path: `/hotel/${searchCriteria.value.id}`, query: query })
        .catch(e => {});

      emit('onClickSearch');
      return;
    }

    const suggest: Suggest.Suggest<Suggest.HotelSuggest> =
      store.getters['suggest/getSuggest'](inputId);

    const hotelId = searchCriteria.value.hotelId;

    const currentRouteParams: Search.SearchRouteParams = await handleRoute(
      route,
    );

    const sameDestination = currentRouteParams?.id === searchCriteria.value.id;
    const sameHotelId = currentRouteParams?.hotelId === hotelId;

    if (hotelId) {
      query.hotelId = hotelId;
    }

    let type = hotelId ? 'hotel' : suggest?.source?.type;

    const composeDestination = (
      suggest: Suggest.Suggest<Suggest.HotelSuggest>,
    ): string => {
      if (!suggest?.source) {
        return '';
      }

      const { sub_title, title } = suggest.source;

      if (sub_title && type === 'hotel') {
        return sub_title;
      }

      return title;
    };

    if (sameDestination || sameHotelId) {
      query.d = currentRouteParams.destintaion ?? composeDestination(suggest);
      query.city = currentRouteParams.city;
      query.state = currentRouteParams.state;
      query.country = currentRouteParams.country;
      if (currentRouteParams.hotel) {
        query.hotel = currentRouteParams.hotel;
      }
      type = currentRouteParams.type;
    } else if (suggest && suggest.source) {
      const suggestSource = suggest.source as Suggest.HotelSuggest;

      query.d = composeDestination(suggest);

      if (hotelId && suggestSource.geo) {
        query.hotel = suggestSource.title;
      } else if (hotelId && suggestSource.title) {
        query.hotel = suggest.title;
      }

      if (suggestSource.geo) {
        if (suggestSource.geo.city) {
          query.city = suggestSource.geo.city;
        }
        if (suggestSource.geo.state) {
          query.state = suggestSource.geo.state;
        }
        if (suggestSource.geo.country) {
          query.country = suggestSource.geo.country;
        }
      }
    }

    if (type) {
      query.type = type;
    }

    if (sameDestination && currentRouteParams.filters) {
      const filters: string = await zipFilters(currentRouteParams.filters);
      query.filters = filters;
    }

    const searchParams = new URLSearchParams(query as any);
    const currentSearchParams = new URLSearchParams(route.query as any);
    searchParams.sort();
    currentSearchParams.sort();

    if (searchParams.toString() === currentSearchParams.toString()) {
      return;
    }

    router
      .push({ path: `/search/${searchCriteria.value.id}`, query: query })
      .catch(e => {
        console.error(e);
      });
    Emitter.$emit(EVENT_NAMES.UPDATE_PROGRESS);

    emit('onClickSearch');
  }

  function setId(payload: { id: string; hotelId?: string }) {
    localCriteria.value.id = payload.id;
    localCriteria.value.hotelId = payload.hotelId;
  }

  function onSelectSuggest(payload: {
    suggest: Suggest.Suggest<Suggest.HotelSuggest>;
    id: Suggest.Ids;
  }) {
    store.commit('suggest/onSelectSuggest', payload);
  }

  watch(searchCriteria, val => {
    localCriteria.value = searchCriteria.value.copyWith({});
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["search-criteria__wrapper border-radius-lg-0", [
        { 'border-radius-sm': _unref(route).name != 'main' },
        { center: _unref(route).name === 'hotel' },
      ]])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(SuggestsSearchComponent, {
          suggestType: _unref(Suggest).Type.HOTEL,
          inputId: _unref(inputId),
          placeholder: _unref(t)('searchForm.textFieldPlaceholder'),
          isEmptyError: noSuggestError.value,
          onRemoveEmptyError: _cache[0] || (_cache[0] = ($event: any) => (noSuggestError.value = false)),
          onOnSuggest: onSuggest
        }, null, 8, ["suggestType", "inputId", "placeholder", "isEmptyError"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(DatepickerDefaultComponent, {
          ref_key: "datepickerRef",
          ref: datepickerRef,
          inDate: _unref(checkin),
          outDate: _unref(checkout),
          labels: [
            _unref(t)('searchForm.calendar.checkInLabel'),
            _unref(t)('searchForm.calendar.checkOutLabel'),
          ],
          onSetDates: setDates
        }, null, 8, ["inDate", "outDate", "labels"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(HotelsTravelersPopupComponent, {
          fieldClassName: __props.traveleresFieldClassName,
          adults: localCriteria.value.adults,
          children: localCriteria.value.children,
          onSetAdults: _cache[1] || (_cache[1] = val => (localCriteria.value.adults = val)),
          onSetChildren: _cache[2] || (_cache[2] = val => (localCriteria.value.children = val)),
          onOnChange: onTravelersChange
        }, null, 8, ["fieldClassName", "adults", "children"])
      ]),
      _createVNode(_Transition, { name: "searchBtnFadeIn" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(ButtonComponent, {
              class: "no-shadow border-radius-lg",
              variant: "secondary",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(onCriteriaChangeDebounced)(true)))
            }, {
              default: _withCtx(() => [
                (_unref(route).name === 'main' || _unref(isMobile))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(t)('searchForm.submitBtnText')), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_7, [
                      _createVNode(_unref(SearchIcon), { fill: "currentColor" })
                    ]))
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ], 2),
    (!_unref(isMobile) && _unref(route).name === 'search')
      ? (_openBlock(), _createBlock(_unref(HeaderHotelsFilterComponent), { key: 0 }))
      : _createCommentVNode("", true)
  ], 512))
}
}

})